
import { createAction } from '@reduxjs/toolkit';

export const createAccountRequest = createAction('CREATE_ACCOUNT_REQUEST', ( data) => {
    return{
        payload: {
			data
        }
    }
	
});

export const createAccountSuccess = createAction('CREATE_ACCOUNT_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});

export const createAccountFailure = createAction('CREATE_ACCOUNT_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});




